<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-10" title="MQTT Management" />
      <div class="col-2">
        <button type="button" @click="showAddMQTTModal" class="btn btn-info btn-rounded mb-2 me-2 w-100">
          <i class="mdi mdi-plus me-1"></i>{{ $t("menuitems.administration.list.mqtt.list.add") }}
        </button>
      </div>
    </div>

    <!-- Company Table -->
    <div class="table-responsive mb-0">
      <b-table class="datatables" :items="mqttData" :fields="fields" responsive="sm" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn">
        <template #cell(created_at)="row">
          <span>{{ new Date(row.item.created_at).toDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span>
        </template>

        <template #cell(package_id)="row">
          {{ getPackageName(row.item.package_id) }}
        </template>

        <template #cell(actions)="row">
          <b-button size="sm" variant="primary" class="m-1" @click="showUpdateMQTTModal(row.item)">
            <i class="mdi mdi-pencil"></i>
            Edit
          </b-button>
          <b-button size="sm" variant="danger" class="m-1" @click="deleteConnection(row.item)">
            <i class="mdi mdi-delete"></i>
            Delete
          </b-button>
        </template>
      </b-table>
    </div>

    <!-- Create company modal -->
    <b-modal id="create-new-connection-modal" title="Create New Company" title-class="font-18" no-close-on-backdrop
      hide-footer size="lg">
      <template #modal-header>
        <div>
          <h5>Add New Connection</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="closeAddNewModal()">
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="createNewConnection">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">Connection Name</th>
                        <td>
                          <input placeholder="Enter Connection Name" v-model="newApiObj.connectionName" type="text"
                            class="form-control" required />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Type</th>
                        <td>
                          <v-select class="style-chooser" v-model="newApiObj.connectionType"
                            :options="apiTypes"></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Package</th>
                        <td>
                          <v-select class="style-chooser" v-model="newApiObj.packageId" :options="packageMaster"
                            :reduce="(packages) => packages.id" label="package_name" required></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">MQTT Server URL</th>
                        <td>
                          <input placeholder="Enter/ Paste MQTT URL" v-model="newApiObj.mqttUrl" type="text"
                            class="form-control" required />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Subscribe Topic</th>
                        <td>
                          <input placeholder="Enter Subscribe Topic" v-model="newApiObj.subscribeTopic" type="text"
                            class="form-control" required />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Add MQTT Connection <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Edit and Update VIDS -->
    <b-modal id="edit-mqtt-modal" title="Create New Company" title-class="font-18" no-close-on-backdrop hide-footer
      size="lg">
      <template #modal-header>
        <div>
          <h5>Update VIDS</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('edit-mqtt-modal')">
            Cancel
          </button>
        </div>
      </template>

      <form @submit.prevent="updateMqtt">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">Connection Name</th>
                        <td>
                          <input placeholder="Enter Connection Name" v-model="selectedConnection.connection_name"
                            type="text" class="form-control" required />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Package</th>
                        <td>
                          <v-select class="style-chooser" v-model="selectedConnection.package_id" :options="packageMaster"
                            :reduce="(packages) => packages.id" label="package_name" required></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Type</th>
                        <td>
                          <v-select class="style-chooser" v-model="selectedConnection.connection_type"
                            :options="apiTypes"></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">MQTT URL</th>
                        <td>
                          <input placeholder="Enter MQTT URL" v-model="selectedConnection.mqtt_url" type="text"
                            class="form-control" required />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Subscribe Topic</th>
                        <td>
                          <input placeholder="Enter Subscribe Topic" v-model="selectedConnection.subscribe_topic"
                            type="text" class="form-control" required />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Update VIDS Location <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import vidsMixin from "../../mixins/administration";
import incidentMixin from "../../mixins/incident";

import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "VIDS Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [vidsMixin, incidentMixin],

  data () {
    return {
      mqttData: [],
      packageMaster: [],
      apiTypes: ['VIDS', 'VSDS', 'ATCC'],
      newApiObj: {},
      selectedConnection: {},
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      options: {
        direction: ["LHS", "RHS"],
        packages: [],
      },
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "connection_name",
          label: "Connection Name",
          sortable: false,
        },
        {
          key: "mqtt_url",
          label: "MQTT URL",
          sortable: false,
        },
        {
          key: "connection_type",
          label: "Type",
          sortable: false,
        },
        {
          key: "subscribe_topic",
          label: "Subscribe Topic",
          sortable: false,
        },
        {
          key: "package_id",
          label: "Package",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "Actions",
        },
      ],
    };
  },

  methods: {
    showAddMQTTModal () {
      this.$bvModal.show("create-new-connection-modal");
    },

    showUpdateMQTTModal (mqttData) {
      this.selectedConnection = mqttData;
      this.$bvModal.show("edit-mqtt-modal");
    },

    closeAddNewModal () {
      this.newApiObj = {}
      this.$bvModal.hide("create-new-connection-modal");
    },

    async createNewConnection () {
      try {
        let payload = {
          connection_name: this.newApiObj.connectionName,
          connection_type: this.newApiObj.connectionType,
          mqtt_url: this.newApiObj.mqttUrl,
          package_id: this.newApiObj.packageId,
          subscribe_topic: this.newApiObj.subscribeTopic,
        };

        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.CreateMQTTConnection(payload);
        this.newApiObj = {}
        this.mqttData = await this.GetMQTTConnection();
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("create-new-connection-modal");
        Swal.fire("MQTT Created", "MQTT connection created successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "warning");
      }
    },

    async updateMqtt () {
      try {
        let payload = {
          id: this.selectedConnection.id,
          connection_name: this.selectedConnection.connection_name,
          connection_type: this.selectedConnection.connection_type,
          mqtt_url: this.selectedConnection.mqtt_url,
          package_id: this.selectedConnection.package_id,
          subscribe_topic: this.selectedConnection.subscribe_topic,
        };

        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateMQTTConnection(payload);
        this.selectedConnection = {};
        this.mqttData = await this.GetMQTTConnection();
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("edit-mqtt-modal");
        Swal.fire("Connection Updated", "MQTT Connection updated successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to update connection", "error");
      }
    },

    async deleteConnection (vids) {
      try {
        const id = {
          id: vids.id,
        };

        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.DeleteMQTTConnection(id);
            Swal.fire("Deleted!", "Connection has been deleted.", "success");
            this.mqttData = await this.GetMQTTConnection();
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to delete connection", "error");
      }
    },

    getPackageName (id) {
      const pkg = this.packageMaster.find(p => p.id == id)
      return (pkg) ? pkg.package_name : ''
    }
  },
  components: {
    Layout,
    PageHeader,
  },

  async mounted () {
    this.mqttData = await this.GetMQTTConnection();
    this.packageMaster = await this.GetAllPackages();
  },
};
</script>
